import * as XLSX from 'xlsx';
import { loadingOverlay } from "vuetify-more-component";
export default {

  components: {
    loadingOverlay
  },

  data() {
    return {
      loading: false,
      usuarios: [],
      search: "",
      loading_resuscribir_pedding: false,
      headers: [
        {
          text: "Nombre",
          align: "center",
          sortable: true,
          value: "nombre",
        },
        {
          text: "CUI/DPI",
          align: "center",
          sortable: true,
          value: "cui"
        },
        {
          text: "NIT",
          align: "center",
          sortable: true,
          value: "nit",
        },
        {
          text: "Dirección",
          align: "center",
          sortable: true,
          value: "direccion",
        },
        {
          text: "Teléfono",
          align: "center",
          sortable: true,
          value: "telefono[0].telefono",
        },
        {
          text: "Correo",
          align: "center",
          sortable: true,
          value: "correo"
        },
        {
          text: "Correo Verificado",
          align: "center",
          sortable: true,
          value: "correo_verificado"
        },
        {
          text: "Fecha declaración",
          align: "center",
          sortable: true,
          value: "fecha_declaracion"
        },
        {
          text: "Regimen",
          align: "center",
          sortable: true,
          value: "regimen"
        },
        {
          text: "Forma de pago (últimos 4 digítos)",
          align: "center",
          sortable: true,
          value: "forma_pago[0].ultimos_numeros"
        },
        {
          text: "Nombre del portador de tarjeta",
          align: "center",
          sortable: true,
          value: "forma_pago[0].nombre_portador"
        },
        {
          text: "Colaborador TIC",
          align: "center",
          sortable: false,
          value: "empleado",
        },
        {
          text: "Tipo suscripción",
          align: "center",
          sortable: true,
          value: "abreviatura"
        },
        {
          text: "Acciones",
          align: "center",
          sortable: false,
          value: "actions",
        },
      ],

      dias: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30'],

      dialog_modificar_correo: false,
      item_correo_aux: '',
      correo_nuevo: '',
      loading_correos: false,

      dialog_modificar_contrasena: false,
      loading_contrasena: false,
      item_usuario_aux: '',

      contrasena_nueva: '',


      dialog_modificar_roles: false,
      item_roles_aux: '',
      item_info_usuario: '',
      loading_roles: false,

      roles: [],

      puestoActuales: [],


      dialog_resuscribir_usuario: false,

      item_aux: "",
      loading_resuscribir: false,

      suscripcion_actual: "",
      suscripcion_id: "",


      datos_tarjeta: {
        token: '',
        ultimos_numeros: '',
        nombre_portador: '',
      },

      disabled_btn: true,
      precio: 0,
    };
  },
  async created() {
    await this.getUsuarios();
    await this.getRoles();
  },
  methods: {

    parseXmlToJson(xml) {
      const json = {};
      for (const res of xml.matchAll(/(?:<(\w*)(?:\s[^>]*)*>)((?:(?!<\1).)*)(?:<\/\1>)|<(\w*)(?:\s*)*\/>/gm)) {
        const key = res[1] || res[3];
        const value = res[2] && this.parseXmlToJson(res[2]);
        json[key] = ((value && Object.keys(value).length) ? value : res[2]) || null;
      }
      return json;
    },

    async confirmar_resuscripcion() {
      console.log("aceptando re suscrpcion");
      console.log(this.item_aux);
      this.loading_resuscribir = true;
      try {
        console.log("hay que pagar");
        // await this.getSuscripcionActual();
        console.log("cambio");
        let info_tarjeta = {
          token: this.datos_tarjeta.token,
          client: this.datos_tarjeta.nombre_portador,
          amount: this.precio
        }
        console.log(info_tarjeta);

        try {
          this.loading = true;
          let r = await this.$store.state.services.usuarioService.postPagoSuscripcionRebill(info_tarjeta);
          console.log(r);
          let respuesta = this.parseXmlToJson(r.data);
          console.log("respuesta");
          console.log(respuesta);
          if (respuesta.RebillResponse.RebillResult.Code === "00") {
            console.log("respuesta id");
            console.log(respuesta.RebillResponse.RebillResult.TransactionId);
            let r2 = await this.$store.state.services.administradorService.resuscribirAlusuario
              (
                {
                  usuario_id: this.item_aux.id,
                  referencia_transaccion_id: respuesta.RebillResponse.RebillResult.TransactionId,
                }
              )
            console.log("viendo suscripcion");
            console.log(r2);

          
            if (r2.data.data == false) {
              try {
                let r = await this.$store.state.services.usuarioService.postPagoVoid({ referenceId: respuesta.RebillResponse.RebillResult.TransactionId });
                console.log(r);
                let respuesta_void = this.parseXmlToJson(r.data);
                console.log("respuesta void");
                console.log(respuesta_void);

                if (respuesta_void.VoidResponse.VoidResult.Code === "00") {
                  this.$toast.success("Reembolso realizado con éxito", { timeout: 5000 })

                } else {
                  this.$toast.error("Error al realizar el reembolso , transacción: ", this.requisitos.TransactionId, { timeout: 10000 })
                }
              } catch (error) {
                console.log(error);
                this.$toast.error("Error al contactar con el servidor, para concluir el registro de la tarjeta de crédito", { timeout: 5000 })
              }
            } else {
              this.loading = false;
              this.$toast.info("Pago realizado exitosamente", { timeout: 1000 });
              this.$toast.success(r2.data.message, { timeout: 2000 });
              this.getUsuarios();
            }

          } else {
            this.loading = false;
            if (respuesta.RebillResponse.RebillResult.Code === "51") {
              this.$toast.error("Error al realizar el pago, Fondos insuficientes", { timeout: 5000, position: "top-right" })
            } else if (respuesta.RebillResponse.RebillResult.Code === "05") {
              this.$toast.error("Error al realizar el pago, Tajerta declinada, contacte al proveedor de la tarjeta de crédito", { timeout: 5000, position: "top-right" })
            } else if (respuesta.RebillResponse.RebillResult.Code === "111") {
              this.$toast.error("Error al realizar el pago, Transacción denegada TID inválido", { timeout: 5000, position: "top-right" })
            } else if (respuesta.RebillResponse.RebillResult.Code === "57") {
              this.$toast.error("Error al realizar el pago, Tarjeta bloqueada o cancelada por el banco", { timeout: 5000, position: "top-right" })
            } else if (respuesta.RebillResponse.RebillResult.Code === "132") {
              this.$toast.error("Error al realizar el pago, Declinada, tarjeta reportada como perdida/robada", { timeout: 5000, position: "top-right" })
            }
            sessionStorage.removeItem("CARD_REQUEST");
            // this.volver();
          }
        } catch (error) {
          console.log(error);
          this.$toast.error("Error al realizar el pago, verifique los datos de su tarjeta de crédito", { timeout: 5000 })
          sessionStorage.removeItem("CARD_REQUEST");

        }


        this.loading_resuscribir = false;
        this.dialog_resuscribir_usuario = false;
        this.item_aux = "";

      } catch (error) {
        console.log(error);
        this.loading_resuscribir = false;
        this.item_aux = "";
        this.dialog_resuscribir_usuario = false;
        this.$toast.error("No es posible gestionar la resuscripción, comunícate con soporte")
      }
    },

    async getSuscripcionActual() {
      try {
        let r = await this.$store.state.services.administradorService.getSuscripcionActivaPorId(this.item_aux.id);
        console.log("r", r);
        console.log("suscripcion actual");

        if (r.data.data.length == 0) {
          this.$toast.info("El usuario no posee suscripciones activas, puede proceder a realizar la resuscripción")
          return;
        }

        let fecha_vencimiento = r.data.data[0].fecha_fin;
        let fecha_actual = new Date();
        console.log(fecha_vencimiento);
        console.log(fecha_actual);

        // muestra cuantos dias faltan para que venza la suscripcion
        let fecha_vencimiento_aux = new Date(fecha_vencimiento);
        let fecha_actual_aux = new Date(fecha_actual);
        let dias = fecha_vencimiento_aux.getTime() - fecha_actual_aux.getTime();
        let dias_faltantes = Math.round(dias / (1000 * 60 * 60 * 24));
        console.log(dias_faltantes);
        if (dias_faltantes > 0) {
          this.$toast.info("El usuario posee una suscripción activa, faltan " + dias_faltantes + " días para que venza la suscripción")
        } else {
          this.$toast.info("La ultima suscripción venció el " + fecha_vencimiento)
        }

        this.suscripcion_actual = r.data.data[0].tipo_suscripcion_id;
        this.suscripcion_id = r.data.data[0].id;
        let precio_entero = parseInt(r.data.data[0].tipo_suscripcion.precio.split(".")[0]);
        let precio_decimal = parseInt(r.data.data[0].tipo_suscripcion.precio.split(".")[1]);
        console.log(typeof (precio_entero), typeof (precio_decimal));
        let suma = precio_entero + precio_decimal;
        console.log(suma);
        this.precio = suma;
        console.log(this.precio, typeof (this.precio));
      } catch (error) {
        console.log(error);
        this.$toast.info("El usuario no posee suscripciones activas, puede proceder a realizar la resuscripción")
      }
    },

    async getTokenTarjetaPorId() {
      try {
        let r = await this.$store.state.services.administradorService.getTokenTarjetaPorId(this.item_aux.id);
        console.log("token");
        console.log(r);
        this.disabled_btn = true;
        this.datos_tarjeta.token = r.data.data.token;
        this.datos_tarjeta.nombre_portador = r.data.data.nombre_portador;
        this.datos_tarjeta.ultimos_numeros = r.data.data.ultimos_numeros;
        this.disabled_btn = false;

      } catch (error) {
        this.disabled_btn = true;
        console.log(error);
        this.$toast.error("El usuario no posee tarjetas activas")
      }
    },

    remove(item) {// remueve roles
      console.log(this.puestoActuales);
      this.puestoActuales = this.puestoActuales.filter(x => x !== item.id);
    },

    async realizarResuscripcionManual(item) {
      console.log(item);
      this.item_aux = item;
      this.loading_resuscribir_pedding = true;
      await this.getSuscripcionActual();
      await this.getTokenTarjetaPorId();
      this.loading_resuscribir_pedding = false;
      this.dialog_resuscribir_usuario = true;
    },

    async gestion_permisos(item) {
      console.log("ver permisos");
      console.log(item);
      item.loading_permisos = true;
      this.item_info_usuario = item;
      try {
        let r = await this.$store.state.services.usuarioService.getRolUsuario(item.id);
        console.log("puestos actuales");
        console.log(r);
        let roles = r.data.data[0].rol;
        console.log("roles");
        console.log(roles);
        item.loading_permisos = false;

        roles.forEach(element => {
          this.puestoActuales.push(element.id);
        });

        this.dialog_modificar_roles = true;
      } catch (error) {
        console.log(error);
      }
    },

    async getRoles() {
      try {
        let r = await this.$store.state.services.usuarioService.getRoles();
        console.log("roles");
        console.log(r);
        this.roles = r.data.data;
      } catch (error) {
        console.log(error);
      }
    },

    async actualizar_roles() {
      console.log("actualizar roles");
      console.log(this.puestoActuales);
      let permisos = [];
      this.puestoActuales.forEach(element => {
        permisos.push({ rol_id: element });
      });


      let body_update = {
        usuario_id: this.item_info_usuario.id,
        permisos: permisos
      };

      try {
        this.loading_roles = true;
        let r = await this.$store.state.services.usuarioService.postInsertarPermisos(body_update);
        console.log(r);
        this.$toast.success("Roles actualizados");
        this.dialog_modificar_roles = false;
        this.loading_roles = false;
        this.puestoActuales = [];
        this.item_info_usuario = '';
        this.getUsuarios();
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible actualizar los roles del usuario");
      }
    },

    cancelar_cambio_roles() {
      this.dialog_modificar_roles = false;
      this.loading_roles = false;
      this.puestoActuales = [];
      this.item_info_usuario = '';
    },

    async editItem(item) {
      this.loading = true;
      try {
        let r =
          await this.$store.state.services.administradorService.updateEmpleados(
            item
          );
        if (r.status === 200) {
          await this.getUsuarios();
          this.$toast.success(
            "SE HA ACTUALIZADO EL USUARIO EXITOSAMENTE"
          );
        } else {
          this.$toast.error(
            "Ocurrió un error al intentar actualizar el usuario"
          );
        }
        this.loading = false;
      } catch (error) {
        this.$toast.error(
          "Ocurrió un error al intentar actualizar el usuario"
        );
        this.loading = false;
      }
    },

    exportarExcel() {
      let info = [];
      this.usuarios.forEach(element => {
        let data = {
          NOMBRE: element.nombre,
          CUI: element.cui,
          NIT: element.nit,
          PASSWORD_SAT: element.password_sat,
          DIRECCION: element.direccion,
          TELEFONO: (element.telefono.length > 0) ? element.telefono[0].telefono : '',
          REGIMEN: element.regimen,
          CORREO: (element.correo.length > 0) ? element.correo : '',
          DIA_DECLARACION: element.fecha_declaracion,
          ULTIMOS_NUMEROS_TARJETA: (element.forma_pago.length > 0) ? element.forma_pago[0].ultimos_numeros : '',
          NOMBRE_PORTADOR: (element.forma_pago.length > 0) ? element.forma_pago[0].nombre_portador : '',
          EMPLEADO: element.empleado
        }
        info.push(data);
      });

      let data = XLSX.utils.json_to_sheet(info)
      const workbook = XLSX.utils.book_new()
      const filename = 'usuarios'
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },

    async getUsuarios() {
      this.loading = true;
      try {
        let r =
          await this.$store.state.services.administradorService.getUsuarios();
        console.log("usuarios");
        console.log(r);
        r.data.data.filter((x) => {
          x.nombre =
            (x.primer_nombre === null ? '' : x.primer_nombre) +
            " " +
            (x.segundo_nombre === null ? '' : x.segundo_nombre) +
            " " +
            (x.primer_apellido === null ? '' : x.primer_apellido) +
            " " +
            (x.segundo_apellido === null ? '' : x.segundo_apellido);

          x.loading_permisos = false;
        });
        this.usuarios = r.data.data;
        this.loading = false;
      } catch (error) {
        this.$toast.error(
          "Ocurrió un error al obtener los datos de los usuarios"
        );
        console.log(error);
        this.loading = false;
      }
    },

    async putActualizarDiaDeclaracion(item) {
      try {
        console.log(item);
        let r = await this.$store.state.services.administradorService.putActualizarDiaDeclaracion({ usuario_id: item.id, dia_declaracion: item.fecha_declaracion });
        await this.getUsuarios();
        console.log(r);
      } catch (error) {
        console.log(error);
      }
    },

    modificar_correo(item) {
      console.log(item);
      this.item_correo_aux = item;
      this.dialog_modificar_correo = true;
    },

    async confimar_modificar_correo() {
      if (this.$refs.formCorreoNuevo.validate()) {
        try {
          this.loading_correos = true;
          let r = await this.$store.state.services.usuarioService.cambiar_correo_electronico({ usuario_id: this.item_correo_aux.id, correo_nuevo: this.correo_nuevo, correo_id: this.item_correo_aux.correo_id });
          console.log(r);
          this.$toast.success(r.data.message);
          this.dialog_modificar_correo = false;
          this.loading_correos = false;
          this.item_correo_aux = '';
          this.correo_nuevo = '';
          this.getUsuarios();
        } catch (error) {
          console.log(error);
          this.$toast.error("No es posible cambiar el correo electronico")
        }

      }
    },

    async verificar_correo(id) {
      try {
        let r = await this.$store.state.services.usuarioService.verificar_correo(id);
        console.log(r);
        this.getUsuarios();
      } catch (error) {
        console.log(error);
      }
    },

    async cambiar_contrasena_admin() {
      try {
        this.loading_contrasena = true;
        let r = await this.$store.state.services.usuarioService.cambiar_contrasena_admin({ usuario_id: this.item_usuario_aux.id, pass: this.contrasena_nueva });
        console.log(r);
        this.contrasena_nueva = '';
        this.item_usuario_aux = '';
        this.loading_contrasena = false;
        this.dialog_modificar_contrasena = false;
      } catch (error) {
        console.log(error);
        this.loading_contrasena = false;
      }
    },

    cambiar_contrasena(item) {
      this.item_usuario_aux = item;
      this.dialog_modificar_contrasena = true;
      console.log(this.item_usuario_aux);
    },


  },
};